if (!customElements.get('complementary-products-v2')) {
  customElements.define(
    'complementary-products-v2',
    class ComplementaryProductsV2 extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.complementary-products-v2__track');
        if (!this.track || this.flickity) return;

        this.initializeFlickity();
      }

      disconnectedCallback() {
        window.clearTimeout(this.flickityRetry);
        if (this.flickity) {
          this.flickity.destroy();
          this.flickity = null;
        }
      }

      initializeFlickity() {
        if (!this.isConnected) return;

        if (typeof window.Flickity === 'undefined') {
          this.flickityRetry = window.setTimeout(() => this.initializeFlickity(), 50);
          return;
        }

        this.flickity = new window.Flickity(this.track, {
          accessibility: true,
          cellAlign: 'left',
          cellSelector: '.complementary-products-v2__card',
          contain: true,
          draggable: true,
          freeScroll: true,
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: false,
          setGallerySize: true,
          wrapAround: false
        });
      }
    }
  );
}
